import { getProgressBarClassName, type ScorecardProgressTone } from "../../utils";

import { cn } from "@/lib/utils";

interface ScorecardCriterionProgressBarProps {
  score: number | null | undefined;
  tone?: ScorecardProgressTone;
  className?: string;
}

const ScorecardCriterionProgressBar = ({
  score,
  tone = "neutral",
  className,
}: ScorecardCriterionProgressBarProps) => {
  const width =
    typeof score === "number" && Number.isFinite(score)
      ? `${Math.max(0, Math.min(100, score * 100))}%`
      : "0%";

  return (
    <div className={cn("h-1.5 w-full overflow-hidden rounded-full bg-muted/60", className)}>
      <div
        className={cn("h-full rounded-full transition-all", getProgressBarClassName(tone))}
        style={{ width }}
      />
    </div>
  );
};

export default ScorecardCriterionProgressBar;
